import { render, staticRenderFns } from "./physioPriceEdit.vue?vue&type=template&id=1a0b2444&scoped=true"
import script from "./physioPriceEdit.vue?vue&type=script&lang=js"
export * from "./physioPriceEdit.vue?vue&type=script&lang=js"
import style0 from "./physioPriceEdit.vue?vue&type=style&index=0&id=1a0b2444&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0b2444",
  null
  
)

export default component.exports